const LETTERS_AND_DIGITS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
const SYMBOLS = '@#%+=';

/**
 * A password nobody has to think up: 14 characters, no look-alikes. It begins
 * and ends with a letter or a digit, because a symbol at either end of it
 * jumps to the other side on a right-to-left line — in an Arabic welcome
 * email, someone would read it in the wrong place.
 */
export function generatePassword(length = 14): string {
  const bytes = new Uint32Array(length);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b, i) => {
    const alphabet = i === 0 || i === length - 1 ? LETTERS_AND_DIGITS : LETTERS_AND_DIGITS + SYMBOLS;
    return alphabet[b % alphabet.length];
  }).join('');
}
